let trackedView = false;

export function hasTrackedView() {
  return trackedView;
}

export function markViewAsTracked() {
  trackedView = true;
}

/** @internal — exported for tests to reset between cases. */
export function __resetTrackedViewForTest() {
  trackedView = false;
}
